import React from "react";

let Alexa = React.createClass({
    render() {
        return (
            <div className="AlexaModule-wrapper grid-10">
                <div className="AlexaModule-copy grid-5 grid-s-10 eo-info left">
                    <div className="AlexaModule-icon">
                        <img src="/public/img/features/alexa_icon.png" alt="Alexa icon" />
                    </div>
                    <h2 className="standard">Alexa, manage my WiFi</h2>
                    <p className="standard eo-info-copy">Partnering with the Alexa team at Amazon, we’ve reimagined how you can control and use WiFi throughout your home, using just your voice. If you own an Echo, eero’s custom Alexa skill lets you find your phone (or any other device) based on the eero it’s connected to, pause the internet for dinner, or turn off eero’s LED light at bedtime — with a simple voice command.
                    </p>
                </div>
                <div className="AlexaModule-image hide-s">
                    <div className="AlexaModule-callouts">
                        <div className="AlexaModule-callout">
                            <img src="/public/img/features/alexa_callout_1.svg" alt="Alexa, ask eero to find Jack's phone" />
                        </div>
                        <div className="AlexaModule-callout">
                            <img src="/public/img/features/alexa_callout_2.svg" alt="Jack's iPhone is near the office eero" />
                        </div>
                    </div>
                    <img src="/public/img/features/alexa_device.png" alt="Amazon Alexa device" />
                </div>
            </div>
        );
    }
});

export default Alexa;



/** WEBPACK FOOTER **
 ** ./app/views/anonymous/views/features/components/Alexa.js
 **/